"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFAQ = void 0;
//<ul><li><strong>How do I earn points? </strong>For every </li></ul>
function parseFAQ(html) {
    if (!html)
        return [];
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var items = doc.querySelectorAll('li');
    var result = [];
    var currentQuestion = null;
    var currentAnswer = '';
    items.forEach(function (item) {
        var _a;
        var strong = item.querySelector('strong');
        if (strong) {
            if (currentQuestion)
                result.push({
                    question: currentQuestion,
                    answer: currentAnswer.trim(),
                });
            currentQuestion = ((_a = strong === null || strong === void 0 ? void 0 : strong.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || '';
            currentAnswer = item.innerHTML.replace(strong.outerHTML, '').trim();
        }
        else
            currentAnswer += '<br/>' + item.innerHTML.trim();
    });
    if (currentQuestion) {
        result.push({ question: currentQuestion, answer: currentAnswer.trim() });
    }
    return result;
}
exports.parseFAQ = parseFAQ;
